// All routes that should be excluded from any kind of tracking
export const EXCLUDE_FROM_TRACKING = new Set(['/whistleblowing']);
